// extracted by mini-css-extract-plugin
module.exports = {"content":"content-3-7xF"};